export const reportAbuse = "crc";
export default {reportAbuse};